"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.trackLog.goToSource': '前往来源',
    'whatsapp.trackLog.status.neutral': '中性',
    'whatsapp.trackLog.status.good': '良好',
    'whatsapp.trackLog.status.warning': '警告',
    'whatsapp.trackLog.status.critical': '严重',
    'whatsapp.trackLog.type': '类型：',
};
